/* eslint-disable react/no-did-update-set-state */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import classNames from 'classnames';
import moment from 'moment';
import { CSVLink } from 'react-csv';
import { Line,Pie,Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  //registerables,
  Title
} from "chart.js";

// import makeAnimated from 'react-select/lib/animated';
import Axios from "axios";
// Styles
import './UserDashboard.scss';

// Material UI
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
//import TableSortLabel from '@material-ui/core/TableSortLabel';
//import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
//import { history } from '../../../../store';
//import { Link } from 'react-router';

// Utils
import {
  stableSort,
  getSorting, roundingMoney,
} from '../../../../utils/functions';
import {inAdminPermissions, inFinance} from "../../../../utils/authChecker";

//import Icon from '../../../../global/images/icons/Icon';

import {
  Button, Dialog,
  DialogActions,
  DialogContent, DialogTitle, styled,
  Typography
} from '@material-ui/core';
import PromptDialog from "../../../dialog/PromptDialog";
import {formatNumber, getCurCurrencyOfUnit, getLocalDay} from "../../../../utils/util";
import suspiciousIcon from "../../../../images/quest-state/suspicious.png";
//import BarChart from "../../../../utils/charts/BarChart";
//import getOptions from "react-bootstrap-datetimerangepicker/lib/getOptions";
//import ReactTooltip from "react-tooltip";
//import {getReconciliationRollCsv} from "../../../../epics/adminEpic";
//import {simpleNotification} from "../../../../utils/notifications";

const colors = [
  "rgba(255, 0, 0, 0.2)",     // 纯红
  "rgba(0, 255, 0, 0.2)",     // 纯绿
  "rgba(0, 0, 255, 0.2)",     // 纯蓝
  "rgba(255, 255, 0, 0.2)",   // 黄
  "rgba(255, 0, 255, 0.2)",   // 品红
  "rgba(0, 255, 255, 0.2)",   // 青
  "rgba(128, 0, 0, 0.2)",     // 深红
  "rgba(0, 128, 0, 0.2)",     // 深绿
  "rgba(0, 0, 128, 0.2)",     // 深蓝
  "rgba(128, 128, 0, 0.2)",   // 橄榄绿
  "rgba(128, 0, 128, 0.2)",   // 紫色
  "rgba(0, 128, 128, 0.2)",   // 蓝绿
  "rgba(255, 165, 0, 0.2)",   // 橙色
  "rgba(255, 192, 203, 0.2)", // 粉红
  "rgba(165, 42, 42, 0.2)",   // 棕色
  "rgba(210, 105, 30, 0.2)",  // 巧克力色
  "rgba(255, 69, 0, 0.2)",    // 橙红
  "rgba(0, 100, 0, 0.2)",     // 深绿
  "rgba(75, 0, 130, 0.2)",    // 靛蓝
  "rgba(138, 43, 226, 0.2)",  // 紫罗兰
  "rgba(220, 20, 60, 0.2)",   // 猩红
  "rgba(0, 206, 209, 0.2)",   // 深青
  "rgba(255, 140, 0, 0.2)",   // 深橙
  "rgba(32, 178, 170, 0.2)",  // 浅海绿
  "rgba(255, 20, 147, 0.2)",  // 深粉红
  "rgba(0, 191, 255, 0.2)",   // 深天蓝
  "rgba(105, 105, 105, 0.2)", // 深灰
  "rgba(112, 128, 144, 0.2)", // 板岩灰
  "rgba(70, 130, 180, 0.2)",  // 钢蓝
  "rgba(255, 99, 71, 0.2)",   // 番茄红
  "rgba(60, 179, 113, 0.2)",  // 薄荷绿
  "rgba(123, 104, 238, 0.2)", // 中紫色
  "rgba(255, 215, 0, 0.2)",   // 金色
  "rgba(0, 128, 128, 0.2)",   // 深青
  "rgba(128, 0, 128, 0.2)",   // 深紫
  "rgba(0, 0, 139, 0.2)",     // 深蓝
  "rgba(139, 0, 0, 0.2)",     // 深红
  "rgba(0, 100, 0, 0.2)",     // 深绿
  "rgba(139, 69, 19, 0.2)",   // 深棕
  "rgba(255, 127, 80, 0.2)",  // 珊瑚色
  "rgba(255, 160, 122, 0.2)", // 浅鲑鱼色
  "rgba(240, 128, 128, 0.2)", // 浅珊瑚色
  "rgba(176, 224, 230, 0.2)", // 粉蓝
  "rgba(152, 251, 152, 0.2)", // 浅绿
  "rgba(175, 238, 238, 0.2)", // 淡青
  "rgba(219, 112, 147, 0.2)", // 淡紫
  "rgba(255, 182, 193, 0.2)", // 浅粉红
  "rgba(255, 228, 196, 0.2)", // 米色
  "rgba(230, 230, 250, 0.2)", // 淡紫罗兰
  "rgba(255, 250, 205, 0.2)", // 柠檬绸
  "rgba(240, 255, 240, 0.2)", // 蜜露
  "rgba(245, 255, 250, 0.2)", // 薄荷奶油
  "rgba(240, 248, 255, 0.2)", // 爱丽丝蓝
  "rgba(250, 235, 215, 0.2)", // 古董白
  "rgba(255, 239, 213, 0.2)", // 杏色
  "rgba(255, 222, 173, 0.2)", // 纳瓦霍白
  "rgba(233, 150, 122, 0.2)", // 深鲑鱼色
  "rgba(143, 188, 143, 0.2)", // 深海绿
  "rgba(72, 209, 204, 0.2)",  // 中绿松石
  "rgba(32, 178, 170, 0.2)",  // 浅海绿
  "rgba(135, 206, 250, 0.2)", // 浅天蓝
  "rgba(135, 206, 235, 0.2)", // 天蓝
  "rgba(0, 191, 255, 0.2)",   // 深天蓝
  "rgba(30, 144, 255, 0.2)",  // 道奇蓝
  "rgba(65, 105, 225, 0.2)",  // 皇家蓝
  "rgba(0, 0, 205, 0.2)",     // 中蓝
  "rgba(25, 25, 112, 0.2)",   // 午夜蓝
  "rgba(72, 61, 139, 0.2)",   // 暗板岩蓝
  "rgba(106, 90, 205, 0.2)",  // 板岩蓝
  "rgba(123, 104, 238, 0.2)", // 中紫色
  "rgba(147, 112, 219, 0.2)", // 中紫罗兰
  "rgba(139, 0, 139, 0.2)",   // 深洋红
  "rgba(148, 0, 211, 0.2)",   // 深紫罗兰
  "rgba(153, 50, 204, 0.2)",  // 深兰花紫
  "rgba(186, 85, 211, 0.2)",  // 中兰花紫
  "rgba(128, 0, 128, 0.2)",   // 紫色
  "rgba(221, 160, 221, 0.2)", // 梅红
  "rgba(238, 130, 238, 0.2)", // 紫罗兰
  "rgba(255, 0, 255, 0.2)",   // 品红
  "rgba(199, 21, 133, 0.2)",  // 深粉红
  "rgba(208, 32, 144, 0.2)",  // 紫罗兰红
  "rgba(219, 112, 147, 0.2)", // 淡紫罗兰
  "rgba(255, 105, 180, 0.2)", // 热粉红
  "rgba(255, 20, 147, 0.2)",  // 深粉红
  "rgba(255, 182, 193, 0.2)", // 浅粉红
  "rgba(250, 128, 114, 0.2)", // 鲑鱼色
  "rgba(233, 150, 122, 0.2)", // 深鲑鱼色
  "rgba(240, 128, 128, 0.2)", // 浅珊瑚色
  "rgba(205, 92, 92, 0.2)",   // 印第安红
  "rgba(139, 69, 19, 0.2)",   // 深棕
  "rgba(160, 82, 45, 0.2)",   // 赭色
  "rgba(210, 105, 30, 0.2)",  // 巧克力色
  "rgba(205, 133, 63, 0.2)",  // 秘鲁色
  "rgba(222, 184, 135, 0.2)", // 棕褐色
  "rgba(245, 222, 179, 0.2)", // 小麦色
  "rgba(244, 164, 96, 0.2)",  // 沙棕色
  "rgba(210, 180, 140, 0.2)", // 黄褐色
  "rgba(188, 143, 143, 0.2)", // 玫瑰棕
  "rgba(165, 42, 42, 0.2)",   // 棕色
  "rgba(128, 0, 0, 0.2)",     // 栗色
  "rgba(139, 0, 0, 0.2)",     // 深红
  "rgba(255, 0, 0, 0.2)",     // 纯红
  "rgba(255, 69, 0, 0.2)",    // 橙红
  "rgba(255, 140, 0, 0.2)",   // 深橙
  "rgba(255, 165, 0, 0.2)",   // 橙色
  "rgba(255, 215, 0, 0.2)"    // 金色
];
const lineColors = [
  "rgba(255, 0, 0, 1)",     // 纯红
  "rgba(0, 255, 0, 1)",     // 纯绿
  "rgba(0, 0, 255, 1)",     // 纯蓝
  "rgba(255, 255, 0, 1)",   // 黄
  "rgba(255, 0, 255, 1)",   // 品红
  "rgba(0, 255, 255, 1)",   // 青
  "rgba(128, 0, 0, 1)",     // 深红
  "rgba(0, 128, 0, 1)",     // 深绿
  "rgba(0, 0, 128, 1)",     // 深蓝
  "rgba(128, 128, 0, 1)",   // 橄榄绿
  "rgba(128, 0, 128, 1)",   // 紫色
  "rgba(0, 128, 128, 1)",   // 蓝绿
  "rgba(255, 165, 0, 1)",   // 橙色
  "rgba(255, 192, 203, 1)", // 粉红
  "rgba(165, 42, 42, 1)",   // 棕色
  "rgba(210, 105, 30, 1)",  // 巧克力色
  "rgba(255, 69, 0, 1)",    // 橙红
  "rgba(0, 100, 0, 1)",     // 深绿
  "rgba(75, 0, 130, 1)",    // 靛蓝
  "rgba(138, 43, 226, 1)",  // 紫罗兰
  "rgba(220, 20, 60, 1)",   // 猩红
  "rgba(0, 206, 209, 1)",   // 深青
  "rgba(255, 140, 0, 1)",   // 深橙
  "rgba(32, 178, 170, 1)",  // 浅海绿
  "rgba(255, 20, 147, 1)",  // 深粉红
  "rgba(0, 191, 255, 1)",   // 深天蓝
  "rgba(105, 105, 105, 1)", // 深灰
  "rgba(112, 128, 144, 1)", // 板岩灰
  "rgba(70, 130, 180, 1)",  // 钢蓝
  "rgba(255, 99, 71, 1)",   // 番茄红
  "rgba(60, 179, 113, 1)",  // 薄荷绿
  "rgba(123, 104, 238, 1)", // 中紫色
  "rgba(255, 215, 0, 1)",   // 金色
  "rgba(0, 128, 128, 1)",   // 深青
  "rgba(128, 0, 128, 1)",   // 深紫
  "rgba(0, 0, 139, 1)",     // 深蓝
  "rgba(139, 0, 0, 1)",     // 深红
  "rgba(0, 100, 0, 1)",     // 深绿
  "rgba(139, 69, 19, 1)",   // 深棕
  "rgba(255, 127, 80, 1)",  // 珊瑚色
  "rgba(255, 160, 122, 1)", // 浅鲑鱼色
  "rgba(240, 128, 128, 1)", // 浅珊瑚色
  "rgba(176, 224, 230, 1)", // 粉蓝
  "rgba(152, 251, 152, 1)", // 浅绿
  "rgba(175, 238, 238, 1)", // 淡青
  "rgba(219, 112, 147, 1)", // 淡紫
  "rgba(255, 182, 193, 1)", // 浅粉红
  "rgba(255, 228, 196, 1)", // 米色
  "rgba(230, 230, 250, 1)", // 淡紫罗兰
  "rgba(255, 250, 205, 1)", // 柠檬绸
  "rgba(240, 255, 240, 1)", // 蜜露
  "rgba(245, 255, 250, 1)", // 薄荷奶油
  "rgba(240, 248, 255, 1)", // 爱丽丝蓝
  "rgba(250, 235, 215, 1)", // 古董白
  "rgba(255, 239, 213, 1)", // 杏色
  "rgba(255, 222, 173, 1)", // 纳瓦霍白
  "rgba(233, 150, 122, 1)", // 深鲑鱼色
  "rgba(143, 188, 143, 1)", // 深海绿
  "rgba(72, 209, 204, 1)",  // 中绿松石
  "rgba(32, 178, 170, 1)",  // 浅海绿
  "rgba(135, 206, 250, 1)", // 浅天蓝
  "rgba(135, 206, 235, 1)", // 天蓝
  "rgba(0, 191, 255, 1)",   // 深天蓝
  "rgba(30, 144, 255, 1)",  // 道奇蓝
  "rgba(65, 105, 225, 1)",  // 皇家蓝
  "rgba(0, 0, 205, 1)",     // 中蓝
  "rgba(25, 25, 112, 1)",   // 午夜蓝
  "rgba(72, 61, 139, 1)",   // 暗板岩蓝
  "rgba(106, 90, 205, 1)",  // 板岩蓝
  "rgba(123, 104, 238, 1)", // 中紫色
  "rgba(147, 112, 219, 1)", // 中紫罗兰
  "rgba(139, 0, 139, 1)",   // 深洋红
  "rgba(148, 0, 211, 1)",   // 深紫罗兰
  "rgba(153, 50, 204, 1)",  // 深兰花紫
  "rgba(186, 85, 211, 1)",  // 中兰花紫
  "rgba(128, 0, 128, 1)",   // 紫色
  "rgba(221, 160, 221, 1)", // 梅红
  "rgba(238, 130, 238, 1)", // 紫罗兰
  "rgba(255, 0, 255, 1)",   // 品红
  "rgba(199, 21, 133, 1)",  // 深粉红
  "rgba(208, 32, 144, 1)",  // 紫罗兰红
  "rgba(219, 112, 147, 1)", // 淡紫罗兰
  "rgba(255, 105, 180, 1)", // 热粉红
  "rgba(255, 20, 147, 1)",  // 深粉红
  "rgba(255, 182, 193, 1)", // 浅粉红
  "rgba(250, 128, 114, 1)", // 鲑鱼色
  "rgba(233, 150, 122, 1)", // 深鲑鱼色
  "rgba(240, 128, 128, 1)", // 浅珊瑚色
  "rgba(205, 92, 92, 1)",   // 印第安红
  "rgba(139, 69, 19, 1)",   // 深棕
  "rgba(160, 82, 45, 1)",   // 赭色
  "rgba(210, 105, 30, 1)",  // 巧克力色
  "rgba(205, 133, 63, 1)",  // 秘鲁色
  "rgba(222, 184, 135, 1)", // 棕褐色
  "rgba(245, 222, 179, 1)", // 小麦色
  "rgba(244, 164, 96, 1)",  // 沙棕色
  "rgba(210, 180, 140, 1)", // 黄褐色
  "rgba(188, 143, 143, 1)", // 玫瑰棕
  "rgba(165, 42, 42, 1)",   // 棕色
  "rgba(128, 0, 0, 1)",     // 栗色
  "rgba(139, 0, 0, 1)",     // 深红
  "rgba(255, 0, 0, 1)",     // 纯红
  "rgba(255, 69, 0, 1)",    // 橙红
  "rgba(255, 140, 0, 1)",   // 深橙
  "rgba(255, 165, 0, 1)",   // 橙色
  "rgba(255, 215, 0, 1)"    // 金色
];

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    BarElement,
    Title,
    Tooltip,
    Legend
);

const TableHeaderCell = withStyles(theme => ({
  head: {
    color: '#9b9b9b',
    fontWeight: '400',
    letterSpacing: '1.2px',
    fontSize: '14px',
  },
}))(TableCell);

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
  '& .MuiDialog-paperWidthSm': {
    backgroundColor: '#322d38',
    borderRadius:'8px',
    display:'flex',
    alignItems:'center',
    width:'500px',
    padding:'10px'
  },
  '& .MuiDialogContent-dividers': {
    borderTop:'0px',
    borderBottom:'0px'
  },
  '& .MuiTypography-h6': {
    textTransform:'none'
  },
  '& .pay-note': {
    width:'100%',
    padding:'8px',
    background:'#2d2d2d',
    border:'1px solid #3d3d3d',
    borderRadius: '4pxv',
    color:'#ffffff',
  },
}));

class UserDashboard extends React.Component {
  constructor(props) {
    super(props);
    let endDate = new Date();
    endDate.setHours(23,59,59,999);
    let startDate = new Date();
    startDate.setHours(0,0,0,0);
    if(!props.admin.rollOutsAll.startDate) {
      //startDate.setDate(endDate.getDate() - 7)
    }

    this.props = props;
    this.state = {
      orderBy: false,
      order: 'desc',
      numPage: 1,
      questTab: 2,
      filtersModal: false,
      daysFilter: 1,
      questsOptions: [],
      paypalLoaded: false,
      filters: {
        searchAll: true,
        searchSubject: false,
        searchNoizEmail: false,
        searchNoiz: false,
        paypalStatusAll: true,
        paypalStatusSuccess: false,
        paypalStatusDenied: false,
        paypalStatusPending: false,
        paypalStatusRefunded: false,
        paypalStatusPartiallyRefunded: false,
        searchValue: '',
        startDate:startDate,
        endDate:endDate,
        approveStatus:"0,",
        irs:1,
        region:props?.auth?.user?.permission?.regions[0]?.id||'',
      },

      filtersClear: {
        searchAll: true,
        searchSubject: false,
        searchNoizEmail: false,
        searchNoiz: false,
        paypalStatusAll: true,
        paypalStatusSuccess: false,
        paypalStatusDenied: false,
        paypalStatusPending: false,
        paypalStatusRefunded: false,
        paypalStatusPartiallyRefunded: false,
        searchValue: '',
        startDate:startDate,
        endDate:endDate,
        approveStatus:"0,",
      },
      search:"",
      dateStart:startDate,
      dateEnd:endDate,
      filtersBackup: {},
      sorting: false,
      approveOrderId:"",
      approveType:0,
      deductOrder:{userId:'',userName:'',balance:0,currency:'',deductNote:'',walletBalance:'',email:'',accountBalance:0,orderId:''},
      dialogConfirmOpen:false,
      dialogRefuseOpen:false,
      dialogResultOpen:false,
      dialogRefuseResultOpen:false,
      payResult:false,
      payResultOpen:false,
      payRemind:false,
      payBatch:false,
      paymentsSel:[],
      dialogConfirmBatchOpen:false,
      dialogBatchSuccessOpen:false,
      payBatchSuccess:null,
      dialogBatchFailureOpen:false,
      dialogBatchFailure:[],
      payNote:"",
      balanceTip:"",
      deductNoteTip:"",
      questTableUserId:"",
      selectIndex:0,
    };
  }

  handleStartDateChange = (date) =>{
    //const newDateStart = event.target.value
    //console.log(newDateStart,typeof newDateStart);
    if(date){
     // const date = new Date(newDateStart);
     // date.setHours(0,0,0,0);
      //console.log(date,typeof date);
      this.setState(prevState =>({
        filters:{
          ...prevState.filters,
          startDate:date
        },
        numPage:1,
        //selectIndex:0,
      }),()=>{this.doSearch()});
    }

  }

  handleEndDateChange = (date) =>{
   // const newDateEnd = event.target.value
    if(date){
     // let date = new Date(newDateEnd);
      //date.setHours(23,59,59,999);
      //console.log(date,typeof date);
      this.setState(prevState =>({
        filters:{
          ...prevState.filters,
          endDate:date
        },
        numPage:1,
        //selectIndex:0,
      }),()=>{this.doSearch()});
    }
  }

  handleSelectIndexDateChange = (dateStart,dateEnd) =>{
    // const newDateEnd = event.target.value
    if(dateStart&&dateEnd){
      // let date = new Date(newDateEnd);
      //date.setHours(23,59,59,999);
      //console.log(date,typeof date);
      this.setState(prevState =>({
        filters:{
          ...prevState.filters,
          startDate:dateStart,
          endDate:dateEnd
        },
        numPage:1,
      }),()=>{this.doSearch()});
    }
  }

  UNSAFE_componentWillMount() {
    if (!this.props.admin.rollOuts.isLoading) {
      this.doSearch();
     // this.props.getRollOutRecord(this.state.numPage,this.state.search?this.state.search:',', JSON.stringify(this.state.filters), JSON.stringify(this.state.sorting), token,0);
      this.setState(prevState =>({
        filters:{
          ...prevState.filters,
          irs:0
        }
      }));
    }
    if (!this.props.admin.rollOutsAll.isLoading) {
      //this.props.getRollOutAll(0,',', '{"tip":true,"approveStatus":0}', false, token,0);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { deductOrderId:approveOrderId } = this.props.admin.deduct.data;
    //const { data:approve,isLoading} = this.props.admin.orderLink;
    //const {Pagination:tipPagination } = this.props.admin.rollOutsAll;
    //console.log(approveOrderId,'---',this.state.approveOrderId);
    if (this.state.filters !== prevState.filters||this.state.search!==prevState.search||this.state.sorting!==prevState.sorting) {
      this.setState({
        numPage: 1,
      });
     // this.props.getRollOutRecord(1,this.state.search?this.state.search:',', JSON.stringify(this.state.filters), JSON.stringify(this.state.sorting), token,0);
     // this.props.getRollOutAll(0,',', '{"tip":true,"approveStatus":0}', false, token,0);
    }else if(approveOrderId&&approveOrderId!==this.state.approveOrderId){
      this.doSearch();
      //this.props.getRollOutRecord(this.state.numPage,this.state.search?this.state.search:',', JSON.stringify(this.state.filters), JSON.stringify(this.state.sorting), token,0);
        //this.props.getRollOutAll(0,',', '{"tip":true,"approveStatus":0}', false, token,0);
      this.setState({
        approveOrderId: approveOrderId,
      });
    }
    //this.props.tip(tipPagination?tipPagination.totalUsers:0);
    if ((prevProps.admin.revokeDeduct.isLoading === true && this.props.admin.revokeDeduct.isLoading === false)) {
      // // When login fails or user is trying to hack/test out to date OAuth Code in query string:
      if (this.props.admin.revokeDeduct.errors.hasError) {
      }else{
        this.doSearch();
      }
      this.handleRefuseResultOpen();
    }
    if ((prevProps.admin.deduct.isLoading === true && this.props.admin.deduct.isLoading === false)) {
      // // When login fails or user is trying to hack/test out to date OAuth Code in query string:
      if (this.props.admin.deduct.errors.hasError) {
      }else{
      }
      this.handleResultOpen();
    }
    if ((prevProps.admin.rollOuts.isLoading === true && this.props.admin.rollOuts.isLoading === false)) {
      // // When login fails or user is trying to hack/test out to date OAuth Code in query string:
      if (this.props.admin.rollOuts.errors.hasError) {
      }else{
        if(this.props.admin.rollOuts.startDate){
          this.setState(prevState =>({
            filters:{
              ...prevState.filters,
              startDate:new Date(this.props.admin.rollOuts.startDate),
              //endDate:new Date(this.props.admin.rollOuts.endDate),
            }
          }));
        }
      }
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    //const { token } = this.props.auth;

    if (this.props.admin.quests.isLoading === true && nextProps.admin.quests.isLoading === false) {
      const { data: quests } = nextProps.admin.quests;

      if (quests) {
        const questsOptions = [];
        for (let i = 0; i < quests.length; i++) {
          questsOptions.push({ value: quests[i].id, label: quests[i].title });
        }

        this.setState({
          //questsOptions,
        });
      }
    }

    // If paypal just refreshed, get payments again
    if (this.props.admin.rollOuts.isLoading === true && nextProps.admin.rollOuts.isLoading === false) {
      this.setState({
        //paypalLoaded: true,
      });
      //this.props.getAPaymentList(this.state.numPage, JSON.stringify(this.state.filters), this.state.sorting, token);
    }
  }

  doSearch=()=>{
    const { token } = this.props.auth;
    this.props.getUserVisitRecord(this.state.numPage,this.state.search?this.state.search:',', JSON.stringify(this.state.filters), JSON.stringify(this.state.sorting), token,0);
  }

  paginationRight = () => {
    const { pagination } = this.props.admin.reconciliationRolls;
    if (pagination.totalPages < this.state.numPage + 1) {
      return;
    }
    if (!this.props.admin.rollOuts.isLoading) {
      //this.props.getRollOutRecord(this.state.numPage + 1,this.state.search?this.state.search:',', JSON.stringify(this.state.filters), JSON.stringify(this.state.sorting), token,0);
    }
    this.setState({
      numPage: this.state.numPage + 1,
    },()=>{this.doSearch()});
  }

  paginationLeft = () => {
    if (this.state.numPage === 1) {
      return;
    }
    if (!this.props.admin.rollOuts.isLoading) {
      //this.props.getRollOutRecord(this.state.numPage - 1,this.state.search?this.state.search:',', JSON.stringify(this.state.filters), JSON.stringify(this.state.sorting), token,0);
    }
    this.setState({
      numPage: this.state.numPage - 1,
    },()=>{this.doSearch()});
  }

  handleSearchValueChange(event) {

    this.setState({
      //filters: {
        //...this.state.filters,
       // searchValue: event.target.value,
      //},
      search:event.target.value,
    });
  }

  openFiltersModal = () => {
    this.setState({
      filtersModal: true,
      filtersBackup: { ...this.state.filters },
    });
  }

  closeFiltersModal = () => {
    this.setState({
      filtersModal: false,
      filters: { ...this.state.filtersBackup },
    });
  }

  clearFiltersModal = () => {
    this.setState({
      filters: { ...this.state.filtersClear },
    });
  }

  applyFilters = () => {
    //const { token } = this.props.auth;

    this.setState({
      filtersModal: false,
    });

   // this.props.getAPaymentList(1, JSON.stringify(this.state.filters), this.state.sorting, token);
  }

  changeFilterSearch(name) {
    switch (name) {
      case 'searchAll':
        this.setState({
          filters: {
            ...this.state.filters,
            searchAll: true,
            searchSubject: false,
            searchNoiz: false,
            searchNoizEmail: false,
          },
        });
        break;
      case 'searchSubject':
        this.setState({
          filters: {
            ...this.state.filters,
            searchSubject: !this.state.filters.searchSubject,
            searchAll: false,
          },
        });
        break;
      case 'searchNoizEmail':
        this.setState({
          filters: {
            ...this.state.filters,
            searchNoizEmail: !this.state.filters.searchNoizEmail,
            searchAll: false,
          },
        });
        break;
      case 'searchNoiz':
        this.setState({
          filters: {
            ...this.state.filters,
            searchNoiz: !this.state.filters.searchNoiz,
            searchAll: false,
          },
        });
        break;
      default:
        this.setState({});
    }
  }

  // changePayoutFilter(name) {
  //   switch (name) {
  //     case 'paymentStatusAll':
  //       this.setState({
  //         filters: {
  //           ...this.state.filters,
  //           paymentStatusAll: !this.state.filters.paymentStatusAll,
  //           paymentStatusSent: false,
  //           paymentStatusFailed: false,
  //           paymentStatusNotSent: false,
  //         },
  //       });
  //       break;
  //     case 'paymentStatusSent':
  //       this.setState({
  //         filters: {
  //           ...this.state.filters,
  //           paymentStatusSent: !this.state.filters.paymentStatusSent,
  //           paymentStatusAll: false,
  //         },
  //       });
  //       break;
  //     case 'paymentStatusFailed':
  //       this.setState({
  //         filters: {
  //           ...this.state.filters,
  //           paymentStatusFailed: !this.state.filters.paymentStatusFailed,
  //           paymentStatusAll: false,
  //         },
  //       });
  //       break;
  //     case 'paymentStatusNotSent':
  //       this.setState({
  //         filters: {
  //           ...this.state.filters,
  //           paymentStatusNotSent: !this.state.filters.paymentStatusNotSent,
  //           paymentStatusAll: false,
  //         },
  //       });
  //       break;
  //     default:
  //       this.setState({});
  //   }
  // }

  changePayPalFilter(name) {
    switch (name) {
      case 'paypalStatusAll':
        this.setState({
          filters: {
            ...this.state.filters,
            paypalStatusAll: !this.state.filters.paypalStatusAll,
            paypalStatusSuccess: false,
            paypalStatusDenied: false,
            paypalStatusPending: false,
            paypalStatusRefunded: false,
            paypalStatusPartiallyRefunded: false,
          },
        });
        break;
      case 'paypalStatusSuccess':
        this.setState({
          filters: {
            ...this.state.filters,
            paypalStatusSuccess: !this.state.filters.paypalStatusSuccess,
            paypalStatusAll: false,
          },
        });
        break;
      case 'paypalStatusDenied':
        this.setState({
          filters: {
            ...this.state.filters,
            paypalStatusDenied: !this.state.filters.paypalStatusDenied,
            paypalStatusAll: false,
          },
        });
        break;
      case 'paypalStatusPending':
        this.setState({
          filters: {
            ...this.state.filters,
            paypalStatusPending: !this.state.filters.paypalStatusPending,
            paypalStatusAll: false,
          },
        });
        break;
      case 'paypalStatusRefunded':
        this.setState({
          filters: {
            ...this.state.filters,
            paypalStatusRefunded: !this.state.filters.paypalStatusRefunded,
            paypalStatusAll: false,
          },
        });
        break;
      case 'paypalStatusPartiallyRefunded':
        this.setState({
          filters: {
            ...this.state.filters,
            paypalStatusPartiallyRefunded: !this.state.filters.paypalStatusPartiallyRefunded,
            paypalStatusAll: false,
          },
        });
        break;
      default:
        this.setState({});
    }
  }

  setPaymentFromDate = (event) => {
    const { target: { value } } = event;
    if (value) {
      const paymentFromDate = new Date(value).toISOString().slice(0, 10);
      this.setState({
        filters: {
          ...this.state.filters,
          paymentFromDate,
        },
      });
    } else if (value === '') {
      this.setState({
        filters: {
          ...this.state.filters,
          paymentFromDate: null,
        },
      });
    }
  }

  setPaymentToDate = (event) => {
    const { target: { value } } = event;
    if (value) {
      const paymentToDate = new Date(value).toISOString().slice(0, 10);
      this.setState({
        filters: {
          ...this.state.filters,
          paymentToDate,
        },
      });
    } else if (value === '') {
      this.setState({
        filters: {
          ...this.state.filters,
          paymentToDate: null,
        },
      });
    }
  }

  // Determine sort direction for property; set state.order and state.orderBy
  handleRequestSort = (event, property) => {
    if(property) {
      const desc = this.state.order === 'desc' && this.state.orderBy === property;
      this.setState({
        order: desc ? 'asc' : 'desc',
        orderBy: property,
        sorting: {
          order: desc ? 'asc' : 'desc',
          orderBy: property ? property : false,
        },
        numPage: 1,
      }, () => {
        this.doSearch()
      });
    }
  }

  handleQuestFilterChange(selectedOptions) {
    this.setState({
      filters: {
        ...this.state.filters,
        quests: selectedOptions,
      },
    });
  }

  renderFiltersModal() {
    return (
      <section className="ModalMaster active">
        <section className="Modal active">
          <button onClick={this.closeFiltersModal.bind(this)} className="Modal__layer" aria-hidden />
          <section className="Modal__wrapper Filters">
            <div className="Filters__title">
              Select the filters you want to apply
            </div>

            <div className="Filters__title left">
              Report for a specific user:
            </div>

            <div className="Filters__section">
              <div style={{ display: 'flex', alignItems: 'baseline' }}>
                <div className="Filters__field__label" style={{ marginRight: '10px' }}>
                  Search by:
                </div>
                <div className="Filters__fieldGroup" style={{ marginTop: '0px', marginBottom: '0px' }}>
                  <button
                    onClick={this.changeFilterSearch.bind(this, 'searchAll', false)}
                    className={classNames('', { active: this.state.filters.searchAll })}
                  >
                    All
                  </button>
                  <button
                    onClick={this.changeFilterSearch.bind(this, 'searchSubject', false)}
                    className={classNames('', { active: this.state.filters.searchSubject })}
                  >
                    Subject
                  </button>
                  <button
                    onClick={this.changeFilterSearch.bind(this, 'searchNoizEmail')}
                    className={classNames('', { active: this.state.filters.searchNoizEmail })}
                  >
                    Noiz Email
                  </button>
                  <button
                    onClick={this.changeFilterSearch.bind(this, 'searchNoiz')}
                    className={classNames('', { active: this.state.filters.searchNoiz })}
                  >
                    Noiz Username
                  </button>
                </div>
              </div>
              <div className="Filters__fieldGroup" style={{ marginTop: '0px' }}>
                <input
                  type="text"
                  value={this.state.filters.searchValue}
                  onChange={this.handleSearchValueChange.bind(this)}
                  style={{ display: 'flex' }}
                />
              </div>
            </div>

            <div className="Filters__title left">
              Filter options:
            </div>


            <div className="Filters__section">
              {/* <div style={{ display: 'flex', alignItems: 'baseline' }}>
                <div className="Filters__field__label" style={{ marginRight: '10px' }}>
                  Payout Status:
                </div>
                <div className="Filters__fieldGroup" style={{ marginTop: '0px', marginBottom: '0px' }}>
                  <button
                    onClick={this.changePayoutFilter.bind(this, 'paymentStatusAll')}
                    className={classNames('', { active: this.state.filters.paymentStatusAll })}
                  >
                    All
                  </button>
                  <button
                    onClick={this.changePayoutFilter.bind(this, 'paymentStatusSent')}
                    className={classNames('', { active: this.state.filters.paymentStatusSent })}
                  >
                    Sent
                  </button>
                  <button
                    onClick={this.changePayoutFilter.bind(this, 'paymentStatusFailed')}
                    className={classNames('', { active: this.state.filters.paymentStatusFailed })}
                  >
                    Failed
                  </button>
                  <button
                    onClick={this.changePayoutFilter.bind(this, 'paymentStatusNotSent')}
                    className={classNames('', { active: this.state.filters.paymentStatusNotSent })}
                  >
                    Not Sent
                  </button>
                </div>
              </div> */}
              <div style={{ display: 'flex', alignItems: 'baseline' }}>
                <div className="Filters__field__label" style={{ marginRight: '10px', marginTop: '20px' }}>
                  PayPal Status:
                </div>
                <div className="Filters__fieldGroup" style={{ marginTop: '0px', marginBottom: '0px' }}>
                  <button
                    onClick={this.changePayPalFilter.bind(this, 'paypalStatusAll')}
                    className={classNames('', { active: this.state.filters.paypalStatusAll })}
                  >
                    All
                  </button>
                  <button
                    onClick={this.changePayPalFilter.bind(this, 'paypalStatusSuccess')}
                    className={classNames('', { active: this.state.filters.paypalStatusSuccess })}
                  >
                    Success
                  </button>
                  <button
                    onClick={this.changePayPalFilter.bind(this, 'paypalStatusDenied')}
                    className={classNames('', { active: this.state.filters.paypalStatusDenied })}
                  >
                    Denied
                  </button>
                  <button
                    onClick={this.changePayPalFilter.bind(this, 'paypalStatusPending')}
                    className={classNames('', { active: this.state.filters.paypalStatusPending })}
                  >
                    Pending
                  </button>
                  <button
                    onClick={this.changePayPalFilter.bind(this, 'paypalStatusRefunded')}
                    className={classNames('', { active: this.state.filters.paypalStatusRefunded })}
                  >
                    Refunded
                  </button>
                  <button
                    onClick={this.changePayPalFilter.bind(this, 'paypalStatusPartiallyRefunded')}
                    className={classNames('', { active: this.state.filters.paypalStatusPartiallyRefunded })}
                  >
                    Partially Refunded
                  </button>
                </div>
              </div>
            </div>

            <div className="Filters__section" style={{ marginTop: '20px', display: 'flex', alignItems: 'center' }}>
              <div className="Filters__field__label" style={{ marginRight: '10px', marginTop: '20px', float: 'left' }}>
                Transaction Date:
              </div>
              <div className="date__section">
                From Date
                <input
                  type="date"
                  value={this.state.filters.paymentFromDate}
                  onChange={this.setPaymentFromDate.bind(this)}
                  className="date__picker"
                />
              </div>
              <span style={{ margin: '0px 10px' }}> - </span>
              <div className="date__section">
                To Date
                <input
                  type="date"
                  value={this.state.filters.paymentToDate}
                  onChange={this.setPaymentToDate.bind(this)}
                  className="date__picker"
                />
              </div>
            </div>
            <div className="Filters__section" style={{ marginTop: '20px' }}>
              {/* }  <div className="Filters__fieldGroup">
                <div className="Filters__field__label">
                  Quests:
                </div>
                <Select
                  value={this.state.filters.quests}
                  closeMenuOnSelect={false}
                  components={makeAnimated()}
                  isMulti
                  onChange={(...args) => this.handleQuestFilterChange(...args)}
                  options={this.state.questsOptions}
                  styles={colourStyles}
                />
              </div> */}
            </div>

            <div className="Filters__close" style={{ paddingTop: '20px' }}>
              <button
                onClick={this.closeFiltersModal.bind(this)}
              >
                <i className="fa fa-times" /> Cancel
              </button>
              <button
                onClick={this.clearFiltersModal.bind(this)}
              >
                <i className="fa fa-eraser" /> Clear
              </button>
              <button
                onClick={this.applyFilters.bind(this)}
              >
                <i className="fa fa-check" /> Apply
              </button>
            </div>
          </section>
        </section>
      </section>
    );
  }

  renderFiltersString = (forFileName) => {
    const { filters } = this.state;
    const filterArray = [];

    if (filters.searchAll && filters.searchValue) {
      filterArray.push(`Subject: ${filters.searchValue}`);
      filterArray.push(`Noiz Email: ${filters.searchValue}`);
      filterArray.push(`Noiz Username: ${filters.searchValue}`);
    } else if (filters.searchsearchSubject) {
      filterArray.push(`Subject: ${filters.searchValue}`);
    } else if (filters.searchNoizEmail) {
      filterArray.push(`Noiz Email: ${filters.searchValue}`);
    } else if (filters.searchNoiz) {
      filterArray.push(`Noiz Username: ${filters.searchValue}`);
    }

    // if (filters.paymentStatusAll) {
    //   filterArray.push('Payout Status: All');
    // } else {
    //   let paymentFilters = [];
    //   if (filters.paymentStatusSent) {
    //     paymentFilters.push('Sent');
    //   }
    //   if (filters.paymentStatusFailed) {
    //     paymentFilters.push('Failed');
    //   }
    //   if (filters.paymentStatusNotSent) {
    //     paymentFilters.push('Not Sent');
    //   }
    //   if (paymentFilters.length) {
    //     filterArray.push('Payment Status: ' + paymentFilters.join(", "));
    //   }
    // }

    if (filters.paypalStatusAll) {
      //filterArray.push('Paypal Status: All');
    } else {
      const paypalFilters = [];
      if (filters.paypalStatusPending) {
        paypalFilters.push('Pending');
      }
      if (filters.paypalStatusSuccess) {
        paypalFilters.push('Success');
      }
      if (filters.paypalStatusDenied) {
        paypalFilters.push('Denied');
      }
      if (filters.paypalStatusRefunded) {
        paypalFilters.push('Refunded');
      }
      if (filters.paypalStatusPartiallyRefunded) {
        paypalFilters.push('Partially Refunded');
      }

      if (paypalFilters.length) {
        filterArray.push(`Paypal Status: ${paypalFilters.join(', ')}`);
      }
    }

    // if (filters.quests) {
    //   filterArray.push('Quests: ' + filters.quests.map((quest) => quest.label).join(", "));
    // }

    if (filters.startDate && filters.endDate) {
      filterArray.push(`Date: ${moment(filters.startDate).format('MMMM DD, YYYY')} - ${moment(filters.endDate).format('MMMM DD, YYYY')}`);
    } else if (filters.startDate) {
      filterArray.push(`Date: After ${moment(filters.startDate).format('MMMM DD, YYYY')}`);
    } else if (filters.endDate) {
      filterArray.push(`Date: Before ${moment(filters.endDate).format('MMMM DD, YYYY')}`);
    }

    if (filterArray.length === 0) {
      return 'None';
    }

    // Determine delimiter
    if (forFileName) {
      const filterStrings = filterArray.map(filter => filter.replace(/[^a-z0-9+]+/gi, '-'));
      return filterStrings.join('_');
    }
    return filterArray.join(', ');
  }


  // Sort & define payment rows; return elements to display
  getRollOutsRows = (payments) => {
    if (payments.length) {
      const{ questTableUserId } = this.state;
      const sortedPayments = stableSort(payments, getSorting(this.state.order, this.state.orderBy));
      return sortedPayments.map(payment => (
          <>
        <TableRow hover tabIndex={-1} key={payment.id}>
          <TableCell align="center">{(this.state.selectIndex===1&&payment.rollInSum!==payment.withdrawSum+payment.cdkOrderSum+payment.balance+payment.deduceSum)&&<img
              src={suspiciousIcon}
              alt="Suspicious"
              style={{ width: '16px', height: '16px',marginRight:'10px'}}
          />}{payment.userName ? payment.userName : '-'}</TableCell>
          <TableCell align="center">{getCurCurrencyOfUnit(payment.currency,payment.rollInSum)}{payment.rollInSum>0&&(<i className="fa fa-search" style={{marginLeft:'5px',cursor:'pointer'}} onClick={this.handleRollIns.bind(this,payment.userName)}></i>)}</TableCell>
          <TableCell align="center">{getCurCurrencyOfUnit(payment.currency,payment.balance)}</TableCell>
          <TableCell align="center">{getCurCurrencyOfUnit(payment.currency,payment.withdrawSum)}{(payment.withdrawSum>0)&&(<i className="fa fa-search" style={{marginLeft:'5px',cursor:'pointer'}} onClick={this.handleRollOuts.bind(this,payment.userName)}></i>)}</TableCell>
          <TableCell align="center">{getCurCurrencyOfUnit(payment.currency,payment.cdkOrderSum)}{(payment.cdkOrderSum>0)&&(<i className="fa fa-search" style={{marginLeft:'5px',cursor:'pointer'}} onClick={this.handleCDKOrders.bind(this,payment.userName)}></i>)}</TableCell>
          <TableCell align="center">{getCurCurrencyOfUnit(payment.currency,payment.deduceSum)}{(payment.deduces&&payment.deduces.length>0)&&(<i className={this.state.questTableUserId===payment.userId?"fa fa-minus-square-o":"fa fa-plus-square-o"} style={{marginLeft:'5px',cursor:'pointer'}} onClick={this.handleDeduceItem.bind(this,payment.userId)}></i>)}</TableCell>
          <TableCell align="center">
            <button style={{'backgroundColor':'green','width':'60px'}} onClick={this.handleConfirmOpen.bind(this,payment.userId,payment.userName,payment.balance,payment.accountBalance,payment.currency,payment.userEmail)}>deduct</button>
          </TableCell>
        </TableRow>

            {questTableUserId===payment.userId&&<TableRow>
        <TableCell colspan="7">
        <section className="ToggleTable__table-wrapper__item">
          <section className="ToggleTable__table flex-table">
            <Table>
              <TableHead>
                <TableRow>
                  <TableHeaderCell align="center">Date</TableHeaderCell>
                  <TableHeaderCell align="center">Amount</TableHeaderCell>
                  <TableHeaderCell align="center">Reason for deduction</TableHeaderCell>
                  <TableHeaderCell align="center">Operator</TableHeaderCell>
                  <TableHeaderCell align="center"></TableHeaderCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {payment.deduces&&payment.deduces.length>0&&payment.deduces?.map(d=>(
                <TableRow hover tabIndex={-1} key={d.id}>
                  <TableCell align="center">{d.createdAt ? moment(d.createdAt).format('YYYY-MM-DD h:mm a') : '-'}</TableCell>
                  <TableCell align="center">{getCurCurrencyOfUnit(payment.currency,d.balance)}</TableCell>
                  <TableCell align="center">{d.note ? d.note : '-'}</TableCell>
                  <TableCell align="center">{d.dealUserName ? d.dealUserName : '-'}{d.quitDeductUserName ? '/'+d.quitDeductUserName : ''}</TableCell>
                  <TableCell align="center">
                    {d.status==='d'&&<button style={{'backgroundColor':'#ff0000','width':'60px'}} onClick={this.handleRefuseOpen.bind(this,d.id,d.balance,payment.userName,payment.currency)}>revoke</button>}
                    {d.status==='q'&&<p style={{color:"green",fontSize:"14px"}}>It was revoked on {moment(d.updatedAt).format('YYYY-MM-DD h:mm a')}</p>}
                  </TableCell>
                </TableRow>
                ))}
                {(!payment.deduces||payment.deduces.length<=0)&&(<TableRow> <TableCell align="center" colspan="5">No Records</TableCell></TableRow>)}
              </TableBody>
            </Table>
          </section>
        </section>
        </TableCell>
      </TableRow>}
          </>
      ));
    }
  }

  handleSearchChange(event) {
    //const { target: { value } } = event;
    this.setState({
      search: event.target.value,
    });
  }

  handleSearch = (event) =>{
    const { search } = this.state
    console.log("method search called!,search string is:",search)
    this.setState({
      numPage: 1,
    },()=>{this.doSearch()});
  }

  // Define table headers; return array of headers
  getTableHeaders = () => {
    const tableHeaders = [
      /*{
        id: 'Date', numeric: false, disablePadding: true, label: 'Date',
      },*/
      {
        id: 'userName', numeric: false, disablePadding: true, label: 'UserName',
      },
      {
        id: 'totalPayment', numeric: false, disablePadding: true, label: 'Total payment',
      },
      {
        id: 'walletBalance', numeric: false, disablePadding: true, label: 'Wallet Balance',
      },
      {
        id: 'withdrawnAmount', numeric: false, disablePadding: true, label: 'Withdrawn Amount',
      },
      {
        id: 'cdkAmount', numeric: false, disablePadding: true, label: 'CDK Amount',
      },
      {
        id: 'deductionAmount', numeric: false, disablePadding: true, label: 'Deduction Amount',
      },
      {
        id: '', numeric: true, disablePadding: false, label: 'Action',
      },

    ].filter(header => header !== null);
    return tableHeaders;
  }

  // Define data for csv download; return object with headers and data
  getCSV = (chartData) => {
    const data = [];
    const labels = chartData.labels;
    const datas = chartData.datasets;
    //获取x 分类
    let headers = [{label:" ", key:"row_name"}];
    if(datas&&datas.length>0){
        for(let i = 0;i<datas.length;i++){
          let label;
          if(datas.length>1) {
            label=datas[i].label;
          }else{
            label="value";
          }
          headers.push({label: label.charAt(0).toUpperCase()+label.slice(1), key: label});
          if(datas[i]&&datas[i].data&&datas[i].data.length>0){
            for(let j = 0;j<datas[i].data.length;j++){
              const d1=labels[j];
              const index1=data.findIndex(r=>r.row_name===d1);
                if(index1<0){
                  const obj = {};
                  obj.row_name=d1;
                  obj[label]=datas[i].data[j];
                  data.push(obj);
                }else{
                  data[index1][label]=datas[i].data[j];
                }
            }
          }
        }
    }

    /*if(datas&&datas.length>0){
      const data = datas[i];
      if(!data&&data.data&&data.data.length>0){
        for(let j = 0;j<data.data.length;j++){
          const dataRow = {
            userName: payment.userName,
            userEmail: payment.userEmail,
            paymentEmail: payment.paymentEmail,
            totalPayment: typeof payment.rollInSum === 'number'? getCurCurrencyOfUnit(payment.currency,payment.rollInSum): '-',
            walletBalance: typeof payment.balance === 'number'? getCurCurrencyOfUnit(payment.currency,payment.balance): '-',
            withdrawnAmount: typeof payment.withdrawSum === 'number'? getCurCurrencyOfUnit(payment.currency,payment.withdrawSum): '-',
            cdkAmount: typeof payment.cdkOrderSum === 'number'? getCurCurrencyOfUnit(payment.currency,payment.cdkOrderSum): '-',
            deductionAmount: typeof payment.deduceSum === 'number'? getCurCurrencyOfUnit(payment.currency,payment.deduceSum): '-',
          };

          data.push(dataRow);
        }
      }

    }*/
//console.log(headers,data);
    return { headers, data };
  }

  // Call api to pull down paypal payments.
  refreshRollOuts() {
    const { token } = this.props.auth;
    this.props.getPaypalPayments(token);
    this.setState({
      //paypalLoading: true,
    });
  }

  openDownloadModal1 = () => {
    const { token} = this.props.auth;
    //const isAdmin = user.role === 'admin';
    //const isHelper = user.role === 'helper';
    const isTransactions = inAdminPermissions('Transactions');
    //console.log('isFinance',isFinance);
    if (isTransactions) {
      this.props.getReconciliationRollCsv(0,this.state.search?this.state.search:',', JSON.stringify(this.state.filters), this.state.sorting, token,0);
      this.setState({
        downloadModal: true,
      });
    }
  }

  closeDownloadModal = () => {
    this.setState({
      downloadModal: false,
    });
  }


  renderDownloadModal() {
    const { isLoading, data: payments } = this.props.admin.reconciliationRollsCsv;
    const csv = this.getCSV(payments);
//console.log(isLoading);
    return (
      <section className="ModalMaster active">
        <section className="Modal active">
          <button onClick={this.closeDownloadModal.bind(this)} className="Modal__layer" aria-hidden />
          <section className="Modal__wrapper Modal__download">
            {
              (isLoading) &&
              <div className="Modal__download--spinner">
                <i className="fa fa-spinner fa-spin fa-3x fa-fw" />
              </div>
            }
            {
              (!isLoading) &&
              <div className="Modal__download--content">
                <div className="Modal__download--header">
                  Download
                </div>
                <div className="Modal__download--body">
                  <div className="Modal__download--row">
                    <CSVLink data={csv.data} headers={csv.headers} filename={`Reconciliation-${this.renderFiltersString(true)}.csv`}>
                      <i className="fa fa-download" />&nbsp;{`Search Results (${payments.length})`}
                    </CSVLink>
                  </div>
                </div>
                <div className="Modal__download--footer">
                  <button
                    onClick={this.closeDownloadModal.bind(this)}
                    className="Modal__download--cta"
                  >
                    <i className="fa fa-times" />&nbsp;Close
                  </button>
                </div>
              </div>
            }
          </section>
        </section>
      </section>
    );
  }

  onDrop = (file) => {

    if (file?.target?.files[0]) {
      /* this.setState({
        uploading: req.id,
      }); */

      this.uploadFile(file?.target?.files[0]);
    }
  }

  uploadFile = (file) => {
    const { token } = this.props.auth;

    const formData = new FormData();
    formData.append("file", file);

    Axios({
      method: 'POST',
      url: '/api/v1/admin/user/update-tickets',
      headers: {
        Authorization: `JWT ${token}`,
        "Content-Type": "multipart/form-data",
      },
      data: formData,

    }).then(res => {

      alert('success');
    })
    .catch(err => {
      console.log(err, "err");
      alert('upload failed');
    });
  };

  approveOrder = (orderId,approveType) => {
    //console.log(orderId,approveType);
    if(!orderId||!approveType){
      return;
    }
    const { token } = this.props.auth;

    if (!this.props.admin.approve.isLoading) {
      this.props.approveRollOut(orderId,approveType, token);
    }
  }

  handleConfirmClose = () => {
    this.setState({ dialogConfirmOpen: false,balanceTip: "",deductNoteTip: ""});
  };

  handleConfirmOpen = (userId,userName,walletBalance,accountBalance,currency,email) => {
    this.setState({ dialogConfirmOpen: true,deductOrder:{userId:userId,userName:userName,walletBalance:walletBalance,balance:'',currency:currency,email:email,deductNote:'',accountBalance:accountBalance}});
  };

  handleRefuseClose = () => {
    this.setState({ dialogRefuseOpen: false});
  };

  handleRefuseOpen = (orderId,balance,userName,currency) => {
    this.setState({ dialogRefuseOpen: true,deductOrder:{orderId:orderId,balance:balance,userName:userName,currency:currency}});
  };

  handleResultClose = () => {
    this.setState({ dialogResultOpen: false});
    //this.props.getUserWallet();
  };

  handleResultOpen = () => {
    this.setState({ dialogResultOpen: true});
  };

  handleRefuseResultClose = () => {
    this.setState({ dialogRefuseResultOpen: false});
    //this.props.getUserWallet();
  };

  handleRefuseResultOpen = () => {
    this.setState({ dialogRefuseResultOpen: true});
  };

  submitOrder=()=>{
    if(!this.state.deductOrder||!this.state.filters.region){
      return;
    }
    //console.log(this.state.deductOrder.balance,this.state.deductOrder.walletBalance,this.state.deductOrder.accountBalance,this.state.deductOrder.deductNote)
    if(!this.state.deductOrder.balance||isNaN(this.state.deductOrder.balance)||this.state.deductOrder.balance<=0){
      this.setState({ balanceTip: "Deduction amount must be ＞ 0"});
      return;
    }
    if(this.state.deductOrder.balance>this.state.deductOrder.walletBalance){
      this.setState({ balanceTip: "Insufficient wallet balance"});
      return;
    }
    if(this.state.deductOrder.balance>this.state.deductOrder.accountBalance){
      this.setState({ balanceTip: "The available amount is insufficient"});
      return;
    }
    if(!this.state.deductOrder.deductNote){
      this.setState({ deductNoteTip: "This field is required"});
      return;
    }
      const { token } = this.props.auth;
    //this.props.approveRollOut(this.state.withdrawOrder.orderId,1,token);
    this.props.deductRoll(this.state.deductOrder.userId,this.state.deductOrder.balance,this.state.filters.region,this.state.deductOrder.deductNote,1,token);
    //this.setState({ approveType: 1});
    this.handleConfirmClose();
    //this.handleResultOpen();
  }

  refuseOrder=()=>{
    if(!this.state.deductOrder||!this.state.deductOrder.orderId){
      return;
    }
    const { token } = this.props.auth;
    this.props.revokeDeduct(this.state.deductOrder.orderId,2,token);
    //this.setState({ approveType: 2});
    this.handleRefuseClose();
    //this.handleResultOpen();
  }

  payOrder=()=>{
    const { approvalLink,isLoading} = this.props.admin.orderLink.data;
    //console.log(approvalLink);
    if(!isLoading){
      if(approvalLink){
        window.open(approvalLink, "_blank");
      }
    }
    this.handleResultClose();
  }

  handlePayOrderResult=(result)=>{
    if(result==='success'){
      this.setState({ payResult: true,payResultOpen:true});
    }else{
      this.setState({ payResult: false,payResultOpen:true});
    }
    this.handleConfirmClose();
  }

  handlePayOrderResultClose=()=>{
    this.setState({ payResultOpen:false});
    this.doSearch();
  }

  handlePayRemindOpen=()=>{
    this.setState({ payRemind:true});
  }

  handlePayRemindClose=()=>{
    this.setState({ payRemind:false});
  }

  handlePayRemindConfirm=()=>{
    this.setState({ payRemind:false,payBatch:true});
  }

  handleChangeSel(event,payment) {
    const isChecked = event.target.checked;
    const { paymentsSel } = this.state;
    let sel;
    if(isChecked){
      if(paymentsSel.findIndex(r=>r.orderId===payment.orderId)<0){
        paymentsSel.push(payment);
      }
      sel=paymentsSel;
    }else{
      sel=paymentsSel.filter(r=>r.orderId!==payment.orderId);
    }
    this.setState({
      paymentsSel: sel,
    });
  }

  clearSelectAll = () => {
    this.setState((prevState) => ({
      paymentsSel: []
    }))
  }

  selectAll = () => {
    const { data: payments} = this.props.admin.rollOuts||{};
    this.setState((prevState) => ({
      paymentsSel: payments
    }))
  }

  handleConfirmBatchOpen = () => {
    this.setState({ dialogConfirmBatchOpen: true});
  };

  handleConfirmBatchClose = () => {
    this.setState({ dialogConfirmBatchOpen: false});
  };

  submitOrders=()=>{
    const { isLoading} = this.props.admin.approve;
    if(!isLoading) {
      const {token} = this.props.auth;
      //this.props.approveRollOut(this.state.withdrawOrder.orderId,1,token);
      this.props.showRollOutsPay(this.state.paymentsSel.map(sel=>sel.orderId), token);
      this.setState({approveType: 1});
      this.handleConfirmBatchClose();
      //this.handleResultOpen();
    }
  }

  handleBatchSuccessConfirmationClose = () => {
    this.setState({ dialogBatchSuccessOpen: false});
  };

  handleBatchFailureConfirmationClose = () => {
    this.setState({ dialogBatchFailureOpen: false});
  };

  handlePayNote = () => {
    return this.state.payNote;
  }

  handleDeduceItem = (userId) => {
    const {questTableUserId} = this.state;
    if(questTableUserId&&questTableUserId===userId){
      this.setState({ questTableUserId: ""});
    }else{
      this.setState({ questTableUserId: userId});
    }
  }

  handleRollIns = (userName) =>{
    this.props.changeIndex(0,{dateBegin:this.state.filters.startDate,dateEnd:this.state.filters.endDate,search:userName});
  }

  handleRollOuts = (userName) =>{
    this.props.changeIndex(1,{dateBegin:this.state.filters.startDate,dateEnd:this.state.filters.endDate,search:userName});
  }

  handleCDKOrders = (userName) =>{
    const { user } = this.props.auth;
    const isFinance = inFinance(user);
    this.props.changeIndex(isFinance?3:2,{dateBegin:this.state.filters.startDate,dateEnd:this.state.filters.endDate,search:userName});
  }

  handleAllChange = () =>{
    const { time:et} = this.props.admin.reconciliationRolls||{};
    //const date = new Date(et);
    //console.log('handleAllChange',et,date.toISOString().split('T')[0],date.toLocaleString('sv-SE',dateOptions));
    this.handleSelectIndexDateChange(new Date(et),new Date());
    this.setState({ selectIndex: 1});
  }

  handleMonthChange = () =>{
    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1,0,0,0);
    //console.log('handleMonthChange',firstDayOfMonth,firstDayOfMonth.toISOString().split('T')[0],firstDayOfMonth.toLocaleString('sv-SE',dateOptions));
    this.handleSelectIndexDateChange(firstDayOfMonth,new Date());
    this.setState({ selectIndex: 3});
  }

  handleLastMonthChange = () =>{
    const today = new Date();

    const lastMonthYear = today.getMonth() === 0 ? today.getFullYear() - 1 : today.getFullYear();
    const lastMonth = today.getMonth() === 0 ? 11 : today.getMonth() - 1;

    const firstDayOfMonth = new Date(lastMonthYear, lastMonth, 1,0,0,0);
    //console.log('handleMonthChange',firstDayOfMonth,firstDayOfMonth.toISOString().split('T')[0],firstDayOfMonth.toLocaleString('sv-SE',dateOptions));
    const lastDayOfMonth = new Date(lastMonthYear, lastMonth+1, 0,23,59,59);
    this.handleSelectIndexDateChange(firstDayOfMonth,lastDayOfMonth);
    this.setState({ selectIndex: 4});
  }

  handleYearChange = () =>{
    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), 0, 1,0,0,0);
    //console.log('handleMonthChange',firstDayOfMonth,firstDayOfMonth.toISOString().split('T')[0],firstDayOfMonth.toLocaleString('sv-SE',dateOptions));
    this.handleSelectIndexDateChange(firstDayOfMonth,today);
    this.setState({ selectIndex: 5});
  }

  handleTodayChange = () =>{
    const today = new Date();
    this.handleSelectIndexDateChange(today,today);
    this.setState({ selectIndex: 0});
  }

  handleLastDayChange = () =>{
    const today = new Date();
    const firstDayOfMonth = new Date();
    firstDayOfMonth.setDate(today.getDate()-1);
    this.handleSelectIndexDateChange(firstDayOfMonth,firstDayOfMonth);
    this.setState({ selectIndex: 1});
  }

  handleWeekChange = () =>{
    const today = new Date();
    const day = today.getDay();
    const diff = today.getDate() - day + (day === 0 ? -6 : 1); // 调整到周一
    const firstDayOfMonth = new Date();
    firstDayOfMonth.setDate(diff);
    //console.log(today,day,diff,firstDayOfMonth);
    this.handleSelectIndexDateChange(firstDayOfMonth,today);
    this.setState({ selectIndex: 2});
  }

  getLineOptions = (title,isLegendShow) => {
    return {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        title: {
          display: true,
          text: title, // 图表标题
          color: '#CDCCD0', // 标题颜色
          font: {size: 16},
        },
        tooltip: {
          mode: 'index', // 显示同一x轴位置所有数据
          intersect: false,
        },
        legend: {
          display: isLegendShow, // 显示图例
          position: 'top', // 图例位置
          labels: {
            color: '#CDCCD0', // 图例文字颜色
          },
        },
      }
    }
  }

  getPieOptions = (title) =>{
    return {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        title: {
          display: true,
          text: title, // 图表标题
          color: '#CDCCD0', // 标题颜色
          font: {size: 16},
        },
        legend: {
          position: 'top',
          labels: {
            color: '#CDCCD0',
            padding: 20
          }
        },
        tooltip: {
          callbacks: {
            label: function(context) {
              const label = context.label || '';
              const value = context.raw || 0;
              const total = context.dataset.data.reduce((a, b) => a + b, 0);
              const percentage = Math.round((value / total) * 100);
              return `${label}: ${percentage}%`;
            }
          }
        }
      },
      cutout: '50%', // 设置饼状图的内切圆半径
      elements: {
        arc: {
          outerRadius: 0.8, // 设置外圆半径为 80% 的默认值
        },
      },
      animation: {
        animateRotate: true,
        animateScale: true,
        duration: 1000
      }
    };
  }

  getDates = () =>{
    const {startDate,endDate} = this.state.filters;
    let dates = [];
    let curDate = new Date(startDate);
    curDate.setHours(0,0,0,0);
    let maxDate = new Date(endDate);
    maxDate.setHours(0,0,0,0);
    while(curDate<=maxDate){
      dates.push(new Date(curDate));
      curDate.setDate(curDate.getDate()+1);
    }
    //console.log('dates',dates,startDate,endDate)
    return dates;
  }

  getVisitData = (data1Title,data1,data2Title,data2) => {
    const dates = this.getDates();
    const data1Filter = dates.map(date=>{
      //console.log('d1',data1.find(d=>{let d1 = new Date(d.createAt);d1.setHours(0,0,0,0);return d1 === date}),new Date('2025-07-01').setHours(0,0,0,0),date.getTime(),new Date('2025-07-01').setHours(0,0,0,0)===date)
      const d1 = data1.find(d=>{let d1 = new Date(d.createAt);d1.setHours(0,0,0,0);return d1.getTime() === date.getTime()});
      return d1?.value||0;
    });
    const data2Filter = dates.map(date=>{
      const d2 = data2.find(d=>{let d1 = new Date(d.createAt);d1.setHours(0,0,0,0);return d1.getTime() === date.getTime()});
      return d2?.value||0;
    });
    //console.log(data1Filter,data2Filter,data1,data2)
    return {
      labels: dates.map(d=>d.toDateString()), // X轴标签
      datasets: [
        {
          label: data1Title, // 数据集名称
          data: data1Filter, // 数据点
          fill: false, // 不填充区域
          backgroundColor: colors[0], // 点背景色
          borderColor: lineColors[0], // 线条颜色
          borderWidth: 2, // 线条宽度
          tension: 0.1, // 线条平滑度
          pointRadius: 4, // 点大小
          pointHoverRadius: 6, // 悬停时点的大小
        },
        {
          label: data2Title, // 数据集名称
          data: data2Filter, // 数据点
          fill: false, // 不填充区域
          backgroundColor: colors[1], // 点背景色
          borderColor: lineColors[1], // 线条颜色
          borderWidth: 2, // 线条宽度
          tension: 0.1, // 线条平滑度
          pointRadius: 4, // 点大小
          pointHoverRadius: 6, // 悬停时点的大小
        }
      ],
    }
  }

  getMutliLineData = (data) => {
    const dates = this.getDates();
    /*let dataNew;
    if(data&&data.length>0){
      data.forEach(d=>{
        const dn = dates.map(date=>{
         const dNew = d.data.find(d1=>d1.date === moment(date).format('YYMMDD'));
         if(dNew===undefined){
           return {date:moment(date).format('YYMMDD'),value:0};
         }else{
           return {...dNew};
         }
        });
        dataNew.push(dn);
      });
    }*/

    //console.log(data,dates.map(d=>moment(d).format('YYYYMMDD')));
    return {
      labels: dates.map(d=>moment(d).format('YYYYMMDD')), // X轴标签
      datasets:(data||[]).map((d,index)=>{return  {
        label: d.name, // 数据集名称
        data: dates.map(date=> d.data?.find(d1=>(d1.date||d1.name) === moment(date).format('YYYYMMDD'))?.value||0), // 数据点
        fill: (data?.length||0)===1, // 不填充区域
        backgroundColor: lineColors[index], // 线条背景景色
        borderColor: lineColors[index], // 线条边框颜色
        pointBackgroundColor: lineColors[index], // 设置数据点背景颜色
        pointBorderColor: lineColors[index],     // 设置数据点边框颜色
        borderWidth: 2, // 线条宽度
        tension: 0.1, // 线条平滑度
        pointRadius: 0.1, // 点大小
        pointHoverRadius: 6, // 悬停时点的大小
      }}),
    }
  }

  getLineData = (data) =>{
    //console.log('getLineData',data);
    const dataNew = [{name:'',data:(data||[])}];
    return this.getMutliLineData(dataNew);
  }



  getInitDate1 = () =>{
    return [{createAt:"2025-07-01",value:10},{createAt:"2025-07-02",value:1},{createAt:"2025-07-03",value:2}];
  }

getInitDate2 = () =>{
  return [{createAt:"2025-07-01",value:3},{createAt:"2025-07-02",value:11},{createAt:"2025-07-03",value:28}];
}

  getInitDate3 = () =>{
    return [{name:"PC",count:3},{name:"MOBILE",count:31},{name:"MAC",count:13}];
  }

  getInitDate4 = () =>{
    return [{name:"baidu",value:3},{name:"sina",value:31},{name:"qq",value:13}];
  }

  getPieData = (data) => {
    const labels = data?.map(d=>d.name)||[];
    const datas = labels?.map(l=>{
      const d1 = data?.find(d=>d.name === l);
      return d1?.value||0;
    })||[];
    return {
      labels: labels,
      datasets: [
        {
          data: datas||[],          // 示例百分比
          backgroundColor: lineColors.slice(0,datas?.length||0>lineColors.length?lineColors.length:datas?.length||0), // 点背景色
          borderColor: '#272e3b',
          borderWidth: 2,
          hoverOffset: 10
        }
      ]
    }
  }
  getRankBarOptions = (title) =>{
return {
  indexAxis: 'y', // 横向柱状图核心配置
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    title: {
      display: true,
      text: title, // 图表标题
      color: '#CDCCD0', // 标题颜色
      font: {size: 16},
    },
    legend: { display: false }, // 隐藏图例
    tooltip: {
      callbacks: {
        label: (context) => `Rank: ${context.dataIndex + 1} | Value: ${context.raw}`
      }
    },
    datalabels: {
      color: '#fff',
      anchor: 'end', // 标签位置
      align: 'end',
      formatter: (value) => value,
      font: { weight: 'bold', size: 12 }
    }
  },
  scales: {
    x: {
      beginAtZero: true,
      grid: { display: false }
    },
    y: {
      grid: { display: false },
      ticks: {
        font: { size: 14 },
        autoSkip: false, // 禁用自动跳过标签
      }
    }
  }
}
  }

  getBarOptions = (title,isLegendShow) =>{
    return {
      indexAxis: 'x', // 横向柱状图核心配置
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        title: {
          display: true,
          text: title, // 图表标题
          color: '#CDCCD0', // 标题颜色
          font: {size: 16},
        },
        legend: { display: isLegendShow }, // 隐藏图例
        tooltip: {
          callbacks: {
            label: (context) => `Name: ${context.dataset.label} | Value: ${context.raw}`
          }
        },
        datalabels: {
          color: '#fff',
          anchor: 'end', // 标签位置
          align: 'end',
          formatter: (value) => value,
          font: { weight: 'bold', size: 12 }
        }
      },
      scales: {
        x: {
          beginAtZero: true,
          grid: { display: false }
        },
        y: {
          grid: { display: false },
          ticks: {
            font: { size: 14 },
            autoSkip: false, // 禁用自动跳过标签
          }
        }
      },
    }
  }

  getRankBarData = (data) => {
    const sortedData = data?[...data].sort((a, b) => b.value - a.value):[];
    //console.log('sortedData',sortedData);
    return {
      labels: sortedData.map(item => item.name)||[], // 标签（如名称）
          datasets: [
      {
        axis: 'y', // 横向柱状图关键配置
        data: sortedData.map(item => item.value),
        backgroundColor:  lineColors.slice(0,sortedData?.length||0>lineColors.length?lineColors.length:sortedData?.length||0), // 高辨识度颜色
        borderWidth: 1,
        borderColor: '#272e3b',
        borderRadius: 4,
        barPercentage: 0.7, // 柱子宽度
      }
    ]

    }
  }

  getMutliBarData = (data,isDay=false) => {
    let labels = [];
    if (isDay) {
      const dates = this.getDates();
      labels = dates.map(d => moment(d).format('YYYYMMDD'))
    } else {
    (data || []).forEach(d => {
      if (d.data && d.data.length > 0) {
        d.data.forEach(dd => {
          if (!labels.includes(dd.name || dd.date)) {
            labels.push(dd.name || dd.date);
          }
        });
      }
    });
  }
    return  {
      labels: labels, // 标签（如名称）
      datasets: (data||[]).map((d,index)=>{
        return {
          label: d.name, // 数据集名称
          axis: 'x',
          data: labels?.map(l=> d.data?.find(d1=>(d1.name||d1.date) === l)?.value||0),
          backgroundColor:  lineColors[index], // 高辨识度颜色
          borderWidth: 1,
          borderColor: '#272e3b',
          borderRadius: 4,
          barPercentage: 0.8, // 柱子宽度(没有设置 barThickness 时才会生效)
          barThickness: labels?.length<8?30:undefined,
        }
      })
    }
  }

  getBarData = (data,isDay=false) => {
    const dataNew = [{name:'name',data:(data||[])}];
    return this.getMutliBarData(dataNew,isDay);
  }

  render() {
    const { data:charts } = this.props.admin.userVisit||{};
    //const {isTipLoading, tipPagination } = this.props.admin.rollOutsAll;
    //const { isLoading: paypalLoading, errors: paypalError } = this.props.admin.rollOuts;
    const { approveType} = this.state;
    const {startDate:dateStart,endDate:dateEnd} = this.state.filters;
    //const { role } = this.props.auth.user;
    //const isHelper = role === 'helper';
    //const isFinance = inFinance(this.props.auth.user);
    const { isLoading } = this.props.admin.userVisit;
    const { isLoading:errorLoading,hasError} = this.props.admin.orderLink.errors;
    const { isLoading:approveLoading,hasError:hasApproveError} = this.props.admin.deduct.errors;
    const { hasError:hasRevokeError} = this.props.admin.revokeDeduct.errors;
    //const { approvalLink} = this.props.admin.orderLink.data;
    //console.log(this.props.admin.userVisit);
    const { deductOrder,dialogConfirmOpen,dialogRefuseOpen,dialogResultOpen,dialogRefuseResultOpen,payRemind,dialogConfirmBatchOpen } = this.state;
    //console.log(this.props.admin.approve.errors);
    //console.log(dateStart,typeof  dateStart);
    //console.log(dateEnd,typeof  dateEnd);
    //let hasError=false;
    //let haRes=false;
    //const queryRegion = this.props?.auth?.user?.permission?.regions?.find(r=>r.id===this.state.filters.region);
    //console.log(queryRegion,recSum,this.props?.auth?.user?.permission,payments)
    /*const createSortHandler = property => (event) => {
      this.handleRequestSort(event, property);
    };*/
    //this.props.tip(tipPagination?tipPagination.totalUsers:0);
    const visitData = this.getDates().length>7?this.getMutliLineData(charts.chartVisit):this.getMutliBarData(charts.chartVisit,true);
    const visitType = this.getDates().length>7?"line":"bar";
    const visitCsv = this.getCSV(visitData);
    const deviceData = this.getPieData(charts.chartDevice);
    const deviceCsv = this.getCSV(deviceData);
    const sourceData = this.getRankBarData(charts.chartSource);
    const sourceCsv = this.getCSV(sourceData);
    const countryData =this.getPieData(charts.chartCountry);
    const countryCsv = this.getCSV(countryData);
    const loginData = this.getDates().length>7?this.getLineData(charts.chartLogin):this.getBarData(charts.chartLogin,true);
    const loginType = this.getDates().length>7?"line":"bar";
    const loginCsv = this.getCSV(loginData);
    const createData = this.getDates().length>7?this.getLineData(charts.chartCreate):this.getBarData(charts.chartCreate,true);
    const createType = this.getDates().length>7?"line":"bar";
    const createCsv = this.getCSV(createData);
    const fansData = this.getMutliBarData(charts.chartFans);
    const fansCsv = this.getCSV(fansData);
    const rCountryData = this.getPieData(charts.chartRCountry);
    const rCountryCsv = this.getCSV(rCountryData);
    const ageData = this.getPieData(charts.chartAge);
    const ageCsv = this.getCSV(ageData);
    const questData = this.getPieData(charts.chartQuest);
    const questCsv = this.getCSV(questData);
    return (
      <section className="APaymentList">
        <section className="APaymentList__wrapper">
          <section className="ToggleTable">
            <section className="ToggleTable__header">
              <div className="date-flow">
              <div className="date-check">
                <div
                    className="date-check-c">
                  <div className="check-item">
                    <button className={this.state.selectIndex===0?"check-button sel":"check-button"} onClick={this.handleTodayChange.bind(this)}>Today</button>
                    <button
                        className={this.state.selectIndex===1?"check-button sel":"check-button"} onClick={this.handleLastDayChange.bind(this)}>Yesterday
                    </button>
                    <button
                        className={this.state.selectIndex===2?"check-button sel":"check-button"} onClick={this.handleWeekChange.bind(this)}>This Week
                    </button>
                    <button
                        className={this.state.selectIndex===3?"check-button sel":"check-button"} onClick={this.handleMonthChange.bind(this)}>This Month
                    </button>
                    <button
                        className={this.state.selectIndex===4?"check-button sel":"check-button"} onClick={this.handleLastMonthChange.bind(this)}>Last Month
                    </button>
                    <button
                        className={this.state.selectIndex===5?"check-button sel":"check-button"} onClick={this.handleYearChange.bind(this)}>Annual
                    </button>
                    <button
                        className={this.state.selectIndex===6?"check-button sel":"check-button"} onClick={()=>this.setState({ selectIndex: 6})}>
                      <i className="fa fa-calendar mr"></i> Customize
                    </button>
                    {this.state.selectIndex===6&&<div className="date-sel">
                      <input type='date' placeholder="Select Start Date" className='date_input_style' value={getLocalDay(dateStart)} onChange={(e) => this.handleStartDateChange(new Date(e.target.value))}/>
                      <input type='date' placeholder="Select End Date" className='date_input_style' value={getLocalDay(dateEnd)} onChange={(e) =>this.handleEndDateChange(new Date(e.target.value))} min={dateStart}/>
                    </div>}
                  </div>
                  <div className="item-center">
                    {/*<div className="space-item">
                      <div className="space-item-right">
                        <div className="round-full"></div>
                        <span className="text-sm">登录用户</span>
                      </div>
                      <div className="space-item-right">
                        <div className="w-3 h-3 rounded-full bg-secondary"></div>
                        <span className="text-sm">游客</span>
                      </div>
                    </div>*/}
                    <div className="space-item-right">
                      <span className="text-sm">Currently Online:</span>
                      <span className="text-sm-second">{charts.curOnlineUser>charts.curLoginUser?formatNumber(charts.curOnlineUser):formatNumber(charts.curLoginUser)}</span>
                      <span className="text-sm-last">(Logged-In: {formatNumber(charts.curLoginUser)}, Temporary: {charts.curOnlineUser-charts.curLoginUser>0?formatNumber(charts.curOnlineUser-charts.curLoginUser):0})</span>
                    </div>
                  </div>
                </div>
              </div>
                {isLoading && (
                    <section className='loading'>
                      <i className='fa fa-spinner fa-spin fa-3x fa-fw' />
                    </section>
                )}
              <div className="cards">
                <div className="stat-card">
                  <div className="items-start">
                    <div>
                      <p className="text-sm">Total Users</p>
                      <h3 className="text-3xl">{formatNumber(charts.totalUser)}</h3>
                    </div>
                    <div className="bg-primary">
                      <i className="fa fa-users text-primary"></i>
                    </div>
                  </div>
                  {/*<div className="flex items-center text-sm">
                            <span className="text-green-500 flex items-center">
                                <i className="fa fa-arrow-up mr-1"></i> 8.2%
                            </span>
                    <span className="text-gray-400 ml-2">较上月</span>
                  </div>*/}
                </div>

                <div className="stat-card">
                  <div className="items-start">
                    <div className="bg-stat">
                      <p className="text-sm">Active Users</p>
                      <h3 className="text-3xl">{formatNumber(charts.activeUser)}</h3>
                    </div>
                    <div className="bg-primary">
                      <i className="fa fa-user-circle-o text-primary"></i>
                    </div>
                  </div>
                  {/*<div className="flex items-center text-sm">
                            <span className="text-green-500 flex items-center">
                                <i className="fa fa-arrow-up mr-1"></i> 12.5%
                            </span>
                    <span className="text-gray-400 ml-2">较上月</span>
                  </div>*/}
                </div>

                <div className="stat-card">
                  <div className="items-start">
                    <div className="bg-stat">
                      <p className="text-sm">Added Users</p>
                      <h3 className="text-3xl">{formatNumber(charts.addUser)}</h3>
                    </div>
                    <div className="bg-primary">
                      <i className="fa fa-user-plus text-primary"></i>
                    </div>
                  </div>
                  {/*<div className="flex items-center text-sm">
                            <span className="text-green-500 flex items-center">
                                <i className="fa fa-arrow-up mr-1"></i> 5.3%
                            </span>
                    <span className="text-gray-400 ml-2">较上周</span>
                  </div>*/}
                </div>

                <div className="stat-card">
                  <div className="items-start">
                    <div className="bg-stat">
                      <p className="text-sm">Visit Users</p>
                      <h3 className="text-3xl">{formatNumber(charts.visitUser)}</h3>
                    </div>
                    <div className="bg-primary">
                      <i className="fa fa-eye text-primary"></i>
                    </div>
                  </div>
                  {/*<div className="flex items-center text-sm">
                            <span className="text-green-500 flex items-center">
                                <i className="fa fa-arrow-up mr-1"></i> 15.8%
                            </span>
                    <span className="text-gray-400 ml-2">较上月</span>
                  </div>*/}
                </div>
              </div>
                <div className="charts">
                  <div className="chart-item">
                    <div className="item-grid">
                      {(charts.chartVisit&&visitType==="line")&&(<Line data={visitData} options={this.getLineOptions('Daily Visitor',true)}/>)}
                      {(charts.chartVisit&&visitType==="bar")&&(<Bar data={visitData} options={this.getBarOptions('Daily Visitor',true)}/>)}
                    </div>
                    <CSVLink data={visitCsv.data} headers={visitCsv.headers} filename={`DailyVisitor-${this.renderFiltersString(true)}.csv`}>
                      <i className="fa fa-download" />
                    </CSVLink>
                  </div>
                  <div className="chart-item">
                    <div className="item-grid">
                      <Pie data={deviceData} options={this.getPieOptions('Accessible Devices')}/>
                    </div>
                    <CSVLink data={deviceCsv.data} headers={deviceCsv.headers} filename={`AccessibleDevices-${this.renderFiltersString(true)}.csv`}>
                      <i className="fa fa-download" />
                    </CSVLink>
                  </div>
                </div>
                <div className="charts">
                  <div className="chart-item">
                    <div className="item-grid">
                      <Bar data={sourceData} options={this.getRankBarOptions('Access Sources')}/>
                    </div>
                    <CSVLink data={sourceCsv.data} headers={sourceCsv.headers} filename={`AccessSources-${this.renderFiltersString(true)}.csv`}>
                      <i className="fa fa-download" />
                    </CSVLink>
                  </div>
                  <div className="chart-item">
                    <div className="item-grid">
                      <Pie data={countryData} options={this.getPieOptions('Country Distribution Of Visitor')}/>
                    </div>
                    <CSVLink data={countryCsv.data} headers={countryCsv.headers} filename={`CountryDistributionOfVisitor-${this.renderFiltersString(true)}.csv`}>
                      <i className="fa fa-download" />
                    </CSVLink>
                  </div>
                </div>
                <div className="charts">
                  <div className="chart-item">
                    <div className="item-grid">
                      {(charts.chartLogin&&loginType==='line')&&(<Line data={loginData} options={this.getLineOptions('Daily Login',false)}/>)}
                      {(charts.chartLogin&&loginType==='bar')&&(<Bar data={loginData} options={this.getBarOptions('Daily Login',false)}/>)}
                    </div>
                    <CSVLink data={loginCsv.data} headers={loginCsv.headers} filename={`DailyLogin-${this.renderFiltersString(true)}.csv`}>
                      <i className="fa fa-download" />
                    </CSVLink>
                  </div>
                  <div className="chart-item">
                    <div className="item-grid">
                      {(charts.chartCreate&&createType==='line')&&(<Line data={createData} options={this.getLineOptions('Daily Create',false)}/>)}
                      {(charts.chartCreate&&createType==='bar')&&(<Bar data={createData} options={this.getBarOptions('Daily Create',false)}/>)}
                    </div>
                    <CSVLink data={createCsv.data} headers={createCsv.headers} filename={`DailyCreate-${this.renderFiltersString(true)}.csv`}>
                      <i className="fa fa-download" />
                    </CSVLink>
                  </div>
                </div>
                <div className="charts">
                  <div className="chart-item">
                    <div className="item-grid">
                      <Bar data={fansData} options={this.getBarOptions('Number Of Anchor Fans',true)}/>
                    </div>
                    <CSVLink data={fansCsv.data} headers={fansCsv.headers} filename={`NumberOfAnchorFans-${this.renderFiltersString(true)}.csv`}>
                      <i className="fa fa-download" />
                    </CSVLink>
                  </div>
                  <div className="chart-item">
                    <div className="item-grid">
                      <Pie data={rCountryData} options={this.getPieOptions('National Distribution Of Registered Personnel')}/>
                    </div>
                    <CSVLink data={rCountryCsv.data} headers={rCountryCsv.headers} filename={`NationalDistributionOfRegisteredPersonnel-${this.renderFiltersString(true)}.csv`}>
                      <i className="fa fa-download" />
                    </CSVLink>
                  </div>
                </div>
                <div className="charts">
                  <div className="chart-item">
                    <div className="item-grid">
                      <Pie data={ageData} options={this.getPieOptions('Age Distribution Of Registered Personnel')}/>
                    </div>
                    <CSVLink data={ageCsv.data} headers={ageCsv.headers} filename={`AgeDistributionOfRegisteredPersonnel-${this.renderFiltersString(true)}.csv`}>
                      <i className="fa fa-download" />
                    </CSVLink>
                  </div>
                  <div className="chart-item">
                    <div className="item-grid">
                      <Pie data={questData} options={this.getPieOptions('Quest Access Distribution Of Registered Personnel')}/>
                    </div>
                    <CSVLink data={questCsv.data} headers={questCsv.headers} filename={`QuestAccessDistributionOfRegisteredPersonnel-${this.renderFiltersString(true)}.csv`}>
                      <i className="fa fa-download" />
                    </CSVLink>
                  </div>
                </div>
            </div>
              {/* <div className="ToggleTable__header__left">
                <div className="RecTotal">
                  <div className="RecTotalRemark">Total Users<i className="fa fa-users" style={{textAlign:'right',marginLeft:'10px'}}></i></div>
                  <div className="RecTotalTitle">{getCurCurrencyOfUnit(queryRegion?.currency,recSum?.rollIn||0)}</div>
                </div>
                <div className="RecItems">
                  <div className="RecItemDiv">
                    <div className="RecItem">
                      <div className="RecItemRemark">Active Users<i className="fa fa-user-circle-o" style={{textAlign:'right',marginLeft:'10px'}}></i></div>
                      <div className="RecItemTitle">{getCurCurrencyOfUnit(queryRegion?.currency,recSum?.balance||0)}</div>
                    </div>
                    <div className="RecItem">
                      <div className="RecItemRemark">Added Users<i className="fa fa-user-plus" style={{textAlign:'right',marginLeft:'10px'}}></i></div>
                      <div className="RecItemTitle">{getCurCurrencyOfUnit(queryRegion?.currency,recSum?.withdraw||0)}</div>
                    </div>
                    <div className="RecItem">
                      <div className="RecItemRemark">Browsing Users<i className="fa fa-eye" style={{textAlign:'right',marginLeft:'10px'}}></i></div>
                      <div className="RecItemTitle">{getCurCurrencyOfUnit(queryRegion?.currency,recSum?.cdkOrder||0)}</div>
                    </div>
                    <div style={{marginLeft:'60px'}}>
                      <div style={{textAlign:'right',fontSize:'13px'}}>
                        Currently Online:1000(Login: 842, Temporary: 406)
                      </div>
                    </div>
                  </div>
                <div className="RecSearch">
                  <div className="DateSel">
                    <div>
                      <span className={this.state.selectIndex===1?"SelItem Selected":"SelItem"} onClick={this.handleAllChange.bind(this)}>All</span>
                      <span className={this.state.selectIndex===2?"SelItem Selected":"SelItem"} onClick={this.handleMonthChange.bind(this)}>This Month</span>
                      <span className={this.state.selectIndex===3?"SelItem Selected":"SelItem"} onClick={this.handleLastMonthChange.bind(this)}>Last Month</span>
                      <span className={this.state.selectIndex===4?"SelItem Selected":"SelItem"} onClick={this.handleYearChange.bind(this)}>This Year</span>
                    </div>
                    <div style={{display:'flex'}}>

                      <input type='date' placeholder="Select Start Date" className='date_input_style' value={getLocalDay(dateStart)} onChange={(e) => this.handleStartDateChange(new Date(e.target.value))}/>


                      <input type='date' placeholder="Select End Date" className='date_input_style' value={getLocalDay(dateEnd)} onChange={(e) =>this.handleEndDateChange(new Date(e.target.value))} min={dateStart}/>
                    </div>
                  </div>

                  <div style={{marginTop:'8px'}}>

                  </div>
                </div>
              </div>
              </div>*/}
              {/* <div className="ToggleTable__header__right" style={{display:'flex'}}>
               <button
                  className={classNames('')}
                  onClick={this.openFiltersModal.bind(this)}
                >
                  Filters
                </button>

              </div>*/}
            </section>
          </section>
        </section>
        <BootstrapDialog
            aria-labelledby="customized-dialog-title"
            open={!!dialogConfirmOpen}
        >
          <DialogContent dividers>
            <div style={{display:'flex',justifyContent:'space-between'}}>
              <Typography variant='body1' component="div"  gutterBottom style={{minWidth:'150px',}}>UserName</Typography>
              <Typography variant='body1' component="div"  gutterBottom style={{minWidth:'200px',textAlign:'right'}}>{deductOrder.userName}</Typography>
            </div>
            <div style={{display:'flex',justifyContent:'space-between'}}>
              <Typography variant='body1' component="div"  gutterBottom style={{minWidth:'150px',}}>Wallet Balance</Typography>
              <Typography variant='body1' component="div"  gutterBottom style={{minWidth:'200px',textAlign:'right'}}>{getCurCurrencyOfUnit(deductOrder.currency,deductOrder.walletBalance ? roundingMoney(deductOrder.walletBalance, 2) : '0.00')}</Typography>
            </div>
            <div style={{display:'flex',justifyContent:'space-between'}}>
              <Typography variant='body1' component="div"  gutterBottom style={{minWidth:'150px',}}>Available Amount</Typography>
              <Typography variant='body1' component="div"  gutterBottom style={{minWidth:'200px',textAlign:'right'}}>{getCurCurrencyOfUnit(deductOrder.currency,deductOrder.accountBalance ? roundingMoney(deductOrder.accountBalance, 2) : '0.00')}</Typography>
            </div>
            <div style={{display:'flex',justifyContent:'space-between'}}>
              <Typography variant='body1' component="div"  gutterBottom style={{minWidth:'150px',}}>Deduction Amount</Typography>
              {this.state.balanceTip&&<Typography variant='body1' component="div"  gutterBottom style={{minWidth:'150px',color:'red',fontSize:'14px'}}>
                {this.state.balanceTip}
              </Typography>}
            </div>
            <div style={{display:'flex',justifyContent:'center'}}>
              <input type="text" className="pay-note" label="deductAmountInput" value={this.state.deductOrder.balance} placeholder="Fill in the deduction amount here" maxLength="20" onChange={event => this.setState({ deductOrder:{...this.state.deductOrder,balance: event.target.value},balanceTip: ""})}/>
            </div>
            <div style={{display:'flex',justifyContent:'space-between',marginTop:'10px'}}>
              <Typography variant='body1' component="div"  gutterBottom style={{minWidth:'150px',}}>Reason for deduction</Typography>
              {this.state.deductNoteTip&&<Typography variant='body1' component="div"  gutterBottom style={{minWidth:'150px',color:'red',fontSize:'14px'}}>
                {this.state.deductNoteTip}
              </Typography>}
            </div>
            <div style={{display:'flex',justifyContent:'center'}}>
              <input type="text" className="pay-note" label="PayNoteInput" value={this.state.deductOrder.deductNote} placeholder="Fill in the reason for deduction here" maxLength="100" onChange={event => this.setState({ deductOrder:{...this.state.deductOrder,deductNote: event.target.value },deductNoteTip: ""})}/>
            </div>
            <div style={{display:'flex',justifyContent:'center',flexDirection:'column',marginTop:'10px'}}>
              <p style={{fontSize:'14px',color:'#9b9b9b',marginBottom:'0px'}}>· When making a deduction, if there is insufficient balance due to withdrawal, please cancel the withdrawal request of the user before making the deduction.</p>
              <p style={{fontSize:'14px',color:'#9b9b9b',marginTop:'0px'}}>· After the deduction, the system will notify the user email - {deductOrder.email}</p>
            </div>

          </DialogContent>
          <DialogActions>
            <div style={{display:'flex'}}>
            <div>
            <Button autoFocus style={{fontSize:'16px',fontWeight:'800',backgroundColor:'#0070ba',color:'#fff',borderRadius:'10px',padding:'10px 30px',textTransform:'none',height:'35px',width:'220px'}} onClick={this.handleConfirmClose.bind(this)}>
              Cancel
            </Button>
            </div>
              <div>
            <Button style={{marginLeft:'20px',fontSize:'16px',fontWeight:'800',backgroundColor:'#0070ba',color:'#fff',borderRadius:'10px',padding:'10px 30px',textTransform:'none',height:'35px',width:'220px'}} onClick={this.submitOrder.bind(this)}>
              Make Deduction
            </Button>
              </div>
            </div>
          </DialogActions>
      </BootstrapDialog>

        <BootstrapDialog
            aria-labelledby="customized-dialog-title"
            open={!!dialogConfirmBatchOpen}
        >
          <DialogContent dividers>
            <div style={{display:'flex',justifyContent:'center'}}>
              <Typography variant='body1' component="div"  gutterBottom style={{minWidth:'150px',}}>Order Quantity</Typography>
              <Typography variant='body1' component="div"  gutterBottom style={{minWidth:'200px',textAlign:'right'}}>{this.state.paymentsSel.length}</Typography>
            </div>
            <div style={{display:'flex',justifyContent:'center'}}>
              <Typography variant='body1' component="div"  gutterBottom style={{minWidth:'150px',}}>Amount Paid</Typography>
              <Typography variant='body1' component="div"  gutterBottom style={{minWidth:'200px',textAlign:'right'}}>{getCurCurrencyOfUnit(this.state.paymentsSel[0]?.currency,this.state.paymentsSel.reduce((totalPrice,env)=>{totalPrice+=env.balance;return totalPrice},0.00))}</Typography>
            </div>
            <div style={{display:'flex',justifyContent:'center'}}>
              <Typography variant='body1' component="div"  gutterBottom style={{minWidth:'150px',}}>Method Of Payment</Typography>
              <Typography variant='body1' component="div"  gutterBottom style={{minWidth:'200px',textAlign:'right'}}>PayPal Batch</Typography>
            </div>

          </DialogContent>
          <DialogActions>
            <div style={{display:'flex'}}>
              <div>
                <Button autoFocus style={{fontSize:'16px',fontWeight:'800',backgroundColor:'#0070ba',color:'#fff',borderRadius:'10px',padding:'10px 50px',textTransform:'none',height:'35px',width:'200px'}} onClick={this.handleConfirmBatchClose.bind(this)}>
                  Cancel
                </Button>
              </div>
              <Button style={{fontSize:'16px',fontWeight:'800',backgroundColor:'#0070ba',color:'#fff',borderRadius:'10px',padding:'10px 50px',textTransform:'none',height:'35px',marginLeft:'10px'}} onClick={this.submitOrders.bind(this)}>
              Make Payment
            </Button>
            </div>
          </DialogActions>
        </BootstrapDialog>

        <BootstrapDialog
            aria-labelledby="customized-dialog-title"
            open={!!dialogRefuseOpen}
        >
          <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title" style={{color:hasError?'#ff0000':''}}>
            Do you confirm to revoke the deduction of <p style={{color:'#E7F328',display:'inline'}}>{getCurCurrencyOfUnit(deductOrder.currency,deductOrder.balance ? roundingMoney(deductOrder.balance, 2) : '0.00')}</p> from <p style={{color:'#E7F328',display:'inline'}}>{deductOrder.userName}'s </p> NOIZ wallet balance?
          </DialogTitle>
          <DialogContent dividers>
            <div style={{display:'flex',justifyContent:'center'}}>
              <Typography variant='body1' component="div"  gutterBottom style={{minWidth:'150px',color:hasError?'#ff0000':''}}>

              </Typography>
            </div>
          </DialogContent>
          <DialogActions>
            <Button autoFocus style={{fontSize:'16px',fontWeight:'800',backgroundColor:'#CAC1C4',color:'#fff',borderRadius:'8px',padding:'10px 50px',boxShadow:'0px 4px 8px rgba(0,0,0,0.5)',textTransform:'none'}} onClick={this.handleRefuseClose.bind(this)}>
              Cancel
            </Button>
            <Button style={{marginLeft:'20px',fontSize:'16px',fontWeight:'800',backgroundColor:'#76b452',color:'#fff',borderRadius:'8px',padding:'10px 50px',boxShadow:'0px 4px 8px rgba(0,0,0,0.5)',textTransform:'none'}} onClick={this.refuseOrder.bind(this)}>
              Confirm
            </Button>
          </DialogActions>
        </BootstrapDialog>

        {(!errorLoading||!approveLoading)&&((hasApproveError&&approveType===2)||approveType===1)&&<BootstrapDialog
            aria-labelledby="customized-dialog-title"
            open={!!false}
        >
          <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title" style={{color:(hasError||hasApproveError)?'#ff0000':''}}>
            {approveType===1? 'Failure to deduction' : 'Failure to revoke deduction'}
          </DialogTitle>
          <DialogContent dividers>
            <div style={{display:'flex',justifyContent:'center'}}>
              <Typography variant='body1' component="div"  gutterBottom style={{minWidth:'150px',color:hasError?'#ff0000':''}}>
                {approveType===1&&((hasError)?'': 'Withdrawal progress can be viewed in the transaction history')}
              </Typography>
            </div>
          </DialogContent>
          <DialogActions>
            <Button style={{marginLeft:'20px',fontSize:'16px',fontWeight:'800',backgroundColor:'#CAC1C4',color:'#fff',borderRadius:'8px',padding:'10px 50px',boxShadow:'0px 4px 8px rgba(0,0,0,0.5)',textTransform:'none'}} onClick={this.handleResultClose.bind(this)}>
              Close
            </Button>
            {(!hasError)&&(<Button style={{marginLeft:'20px',fontSize:'16px',fontWeight:'800',backgroundColor:'#76b452',color:'#fff',borderRadius:'8px',padding:'10px 50px',boxShadow:'0px 4px 8px rgba(0,0,0,0.5)',textTransform:'none'}} onClick={this.payOrder.bind(this)}>
              Confirm
            </Button>)}
          </DialogActions>
        </BootstrapDialog>}
        {this.state.dialogResultOpen&&hasApproveError&&<PromptDialog dialogOpen={this.state.dialogResultOpen} level="failure" title="Deduct failed!" content={'Please confirm if the balance is sufficient for deduct.'} cancelAction={this.handleResultClose}/>}
        {this.state.dialogResultOpen&&!hasApproveError&&<PromptDialog dialogOpen={this.state.dialogResultOpen} level="success" title="Deduct Successful!" content={'The user\'s account has been deducted.'} cancelAction={this.handleResultClose}/>}
        {dialogRefuseResultOpen&&!hasRevokeError&&<PromptDialog dialogOpen={dialogRefuseResultOpen} level="success" title="Revoke successful!" content={'The deducted amount from the user\'s wallet has been returned'} cancelAction={this.handleRefuseResultClose}/>}
        {dialogRefuseResultOpen&&hasRevokeError&&<PromptDialog dialogOpen={dialogRefuseResultOpen} level="failure" title="Failure to revoke." content={'Please confirm if there is an account issue.'} cancelAction={this.handleRefuseResultClose}/>}
        {payRemind&&<PromptDialog dialogOpen={dialogResultOpen} level="warn" title="Payment reminder" content={'Batch payment will incur a handling fee,which will be borne by NOIZ.Would you like to confirm the use of batch payment?'} cancelButtonName="Cancel" cancelAction={this.handlePayRemindClose} confirmButtonName="Make Payment" confirmAction={this.handlePayRemindConfirm}/>}
        {this.state.dialogBatchSuccessOpen&&<PromptDialog dialogOpen={this.state.dialogBatchSuccessOpen} level="success" title="Payment Successful!" content={'Amount:'+this.state.payBatchSuccess?.amount+' Order quantity:'+this.state.payBatchSuccess?.orderCount} cancelAction={this.handleBatchSuccessConfirmationClose}/>}
        {this.state.dialogBatchFailureOpen&&<PromptDialog dialogOpen={this.state.dialogBatchFailureOpen} level="failure" title="Payment failed!" content={'Please confirm if the balance is sufficient for payment.'} cancelAction={this.handleBatchFailureConfirmationClose}/>}
        <BootstrapDialog
            aria-labelledby="customized-dialog-title"
            open={!!this.state.dialogBatchFailure.length>0}
        >
          <div className="block_5 flex-row justify-between">
            <div className="text-wrapper_7 flex-col">
              <span className="text_11">!</span>
            </div>
            <div className="text-wrapper_8 flex-col justify-between">
              <span className="text_12">WARNING</span>
              <span className="paragraph_1">
                    6 orders have been successfully paid, and the following 6 orders have failed to be paid. Please confirm if the balance is sufficient.
                    </span>
            </div>
          </div>


          <DialogContent dividers>
            <div className="block_6 flex-row">
              <div className="text-wrapper_9 flex-col">



              </div>
            </div>
          </DialogContent>
          <DialogActions style={{width:'100%',justifyContent:'space-evenly'}}>
            <div className="block_7 flex-row">
              <div className="text-wrapper_10 flex-col" onClick={this.handleBatchFailureConfirmationClose.bind(this)}>
                <span className="text_13">Close</span>
              </div>
            </div>
          </DialogActions>
        </BootstrapDialog>
        {/*{ (this.state.filtersModal) && this.renderFiltersModal() }*/}
        { (this.state.downloadModal) && this.renderDownloadModal() }
      </section>
    );
  }
}

UserDashboard.propTypes = {

};

export default UserDashboard;
